import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'

import { useCloseCommunication } from '@/hooks/api/use-communication'

function ResolveDialog({
    communicationId,
    handleClose,
}: {
    communicationId: number,
    handleClose: () => void,
}) {

    const [requestInProgress, setRequestInProgress] = useState<boolean>(false)
    const [success, setSuccess] = useState<boolean>(false)

    const mutation = useCloseCommunication(
        communicationId,
        {
            setRequestInProgress,
            onSuccessCallback(data) {
                if(data) {
                    setSuccess(true)
                }
            }
        },
    )

    const handleClickResolve = () => {
        setRequestInProgress(true)
        mutation.mutate()
    }

    return (
        <Box sx={{
            minWidth: 200,
            minHeight: 100,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            {success ?
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                    px: 3,
                }}>
                    <CheckCircleRoundedIcon sx={{
                        color: 'terciary.main',
                        fontSize: '4rem',
                    }}/>
                    <Typography variant="body1" component="div">
                        Vlákno komunikace úspěšně vyřešeno a uzavřeno.
                    </Typography>
                    <Button
                        variant="contained"
                        color="terciary"
                        size="small"
                        onClick={() => {
                            setSuccess(false)
                            handleClose()
                        }}
                    >
                        Zavřít
                    </Button>
                </Box>
                :
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <Typography variant="h5" component="div" mb={2}>
                        Potvrďte prosím uzavření vlákna komunikace ID: {communicationId}
                    </Typography>
                    <Typography variant="body2" component="div" mb={2}>
                        Tato akce vlákno uzavře a označí za vyřešené.
                    </Typography>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexGrow: 1,
                    }}>
                        <Button
                            variant="text"
                            color="terciary"
                            onClick={() => handleClose()}
                        >
                            Zrušit
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            startIcon={requestInProgress ? <CircularProgress color="inherit" size={20} /> : <CheckCircleRoundedIcon />}
                            onClick={() => handleClickResolve()}
                            disabled={requestInProgress}
                        >
                            Potvrdit
                        </Button>
                    </Box>
                </Box>
            }
        </Box>
    )
}

export default ResolveDialog
